<div class="select-question">
  <div class="select-question__label">
    <ion-label>{{ question.label }}</ion-label>
  </div>

  <div class="input-group">
    <select
      placeholder="Select an option"
      type="select"
      class="select-question__select"
      [name]="question.key"
      [class.is-invalid]="question.error"
      (change)="onChange()"
      [(ngModel)]="question.editingValue"
      required>

      <option selected disabled value="">- Select Time -</option>
      <option *ngFor="let ts of timeSlots" class="select-question__select__option" [value]="ts">
        {{ ts | timeFormat }}
      </option>
    </select>
  </div>
</div>
